// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const deoxys_attack: PokeData = {
  "id": 10001,
  "name": "deoxys-attack",
  "height": 17,
  "weight": 608,
  "base_experience": 270,
  "types": [
    PokeType.PSYCHIC
  ],
  "api_moves": [
    "wrap",
    "leer",
    "hyper-beam",
    "psychic",
    "teleport",
    "night-shade",
    "zap-cannon",
    "pursuit",
    "taunt",
    "superpower",
    "skill-swap",
    "cosmic-power",
    "psycho-boost",
    "psycho-shift",
    "zen-headbutt",
    "psyshock"
  ],
  "moves": [
    "leer",
    "psychic",
    "night-shade",
    "zap-cannon",
    "pursuit",
    "superpower",
    "zen-headbutt",
    "calm-mind",
    "psychic-terrain",
    "psy-pulse",
    "synchronize",
    "psychic-fangs",
    "healing-wish"
  ],
  "evolution_chain": {
    "id": 202,
    "item": null,
    "species": [
      {
        "name": "deoxys",
        "order": 416,
        "types": [
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 38,
    "speed": 164,
    "ability_power": 197
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": false,
  "is_mythical": true,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
